"use client";
import { Modal } from "antd";
import React from "react";

type AppModalProps = {
  isModalOpen: boolean;
  children: React.ReactNode;
  modalTitle?: string;
  closeModal: () => void;
  customWidth?: string;
  closable?:
    | boolean
    | ({
        closeIcon?: React.ReactNode;
        disabled?: boolean;
      } & React.AriaAttributes)
    | undefined;
  customClass?: string;
  hasMask?: boolean;
  contentClass?: string;
};

const AppModal = ({
  isModalOpen,
  children,
  modalTitle,
  closeModal,
  customWidth = "min(90vw, 900px)",
  closable = { "aria-label": "Custom Close Button" },
  customClass,
  hasMask = true,
  contentClass = "!p-3.5",
}: AppModalProps) => {
  return (
    <Modal
      title={
        modalTitle ? (
          <span className="!text-lg font-bold">{modalTitle}</span>
        ) : null
      }
      closable={closable}
      open={isModalOpen}
      onCancel={() => closeModal()}
      footer={null}
      classNames={{ content: contentClass }}
      width={customWidth}
      styles={{ body: { paddingLeft: 0 } }}
      getContainer={false}
      className={customClass}
      mask={hasMask}
    >
      {children}
    </Modal>
  );
};

export default AppModal;
